export type Element = 'Water' | 'Earth' | 'Metal' | 'Fire' | 'Wood';

export enum ElementEnum {
  'Water' = `Water`,
  'Earth' = `Earth`,
  'Metal' = `Metal`,
  'Fire' = `Fire`,
  'Wood' = `Wood`,
}
